import {
    Banner,
    Genie,
    GenieHeaderButton,
    GenieSidePanel,
    GenieSidebarButton,
    TemplatePageComponent,
    GenieProps,
    GenieFloater,
    AgentStudio,
} from "@kaltura/mediaspace-features-genie";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";
import { createRoot } from "react-dom/client";

export { Banner, Genie, GenieHeaderButton, GenieSidePanel, GenieSidebarButton, TemplatePageComponent };
export const renderGeniePage = getDsLayoutComponentRenderer(Genie);
export const renderAgentStudioPage = getDsLayoutComponentRenderer(AgentStudio);

/** Floating Genie button for non-DS pages. Renders into a dynamically created body-appended div. */
export const FloatingWidget = {
    render: (props: GenieProps) => {
        const rootElement = document.createElement("div");
        document.body.append(rootElement);
        const root = createRoot(rootElement);
        root.render(<GenieFloater {...props} />);
    },
};
